import React from "react";

export const convertColumns = (data, columns) => {
  if (window.innerWidth > 990) {
    return data;
  } else {
    let response = [];
    data.forEach((d, index) => {
      let newob = {};
     // console.log(d);
      columns.forEach((c) => {
      //  console.log(c);
        if (c.con) {
          console.log(d[c.key]);
          newob[c.key] = (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <span className='text-left'>{c.value}</span>
              <span className='text-right'>{typeof d[c.key] === 'object' ? d[c.key].url : d[c.key]}</span>
            </div>
          );
        } else {
          console.log(c.key);
          console.log(d[c.key]);
          newob[c.key] = d[c.key];
        }
      });
      newob.key = index;
      console.log(newob);
      newob.id = d.id;
      if(d.image){
        newob.image = d.image
      }
      if(d.photo){
        newob.photo = d.photo
      }
      if(d.icon){
        newob.icon = d.icon
      }
      response.push(newob);
      console.log(response);
    });
    return response;
  }
};


export const createColumns = (columns, initial) => {
  let obj = [];
  columns.forEach((c,index)=>{
    obj.push({title: c.value, dataIndex: c.key, key: (index + 1).toString()})
  })
  return initial;
};